import React, { useState, useEffect } from 'react';
import IconEmail from '@icons/Email'
import IconInspect from '@icons/Inspect'
import { useEnquiryFormContext } from '@context/EnquiryFormContext'
import MakeOfferButton from '../ContactNav/ContactNavActions/MakeOfferButton'
import useWindowSize from '@hooks/useWindowSize'
import * as S from './PropertyMobileNav.styled'
import * as G from '@styles/MobileNav.styled'
import IconMobile from '@icons/Mobile'
import IconApply from '@icons/Apply'

const PropertyMobileNav = ({ listing }) => {
  const windowSize = useWindowSize()
  const { setShowEnquiryForm } = useEnquiryFormContext()
  const phoneNumber = listing.agents?.find((it) => it.phone)?.phone ?? ''
  const hasInspection = listing.inspections.length > 0

  const goToInspectionSection = () => {
    const top = document.getElementById('inspections').offsetTop
    window.scrollTo({ top: top - 80, left: 0, behavior: 'smooth' })
  }
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  let url = ''
  let book_url = ''
  const irePropertyID = listing.ireID
  if (
    listing.listingType === 'lease' &&
    listing.status !== 'leased' &&
    listing.office_details &&
    listing.office_details.office
  ) {
    if (listing.office_details.office.snug_integration) {
      let street = listing.address_street.split(' ')
      let street_type = street.pop()
      street = street.join(' ')
      if (listing.office_details.office.snug_team_ID != '') {
        let address_information = `?add_unitnum=${listing.address_subNumber}&add_streetnum=${listing.address_streetNumber}&add_streetname=${street}&add_streettype=${street_type}&add_suburb=${listing.address_suburb}&add_state=${listing.address_state}&add_postcode=${listing.address_postcode}`
        let base_url = `https://api.snug.com/v1/partner/handoff/team/${listing.office_details.office.snug_team_ID}/listing/${listing.id}`
        book_url = `${base_url}${address_information}`
        url = `${base_url}/apply${address_information}`
      }
    } else if (
      listing.office_details.office.our_property_integration &&
      listing.office_details.office.our_property_url
    ) {
      url = listing.office_details.office.our_property_url
      book_url = url
    }else if (listing.office_details.office.sorted_integration){
      url = `https://apply.sortedservices.com/#/properties?agentId=AU_BRYP&id=${listing.external_id}&type=a&rent=${listing.rent}`
    } else if (
      irePropertyID !== '' &&
      listing.office_details.office.inspect_re_id_rental_application !== ''
    ) {
      url = `https://2apply.com.au/Form?agentID=${listing.office_details.office.inspect_re_id_rental_application}&uniqueID=${irePropertyID}`
    } else if (listing.office_details.office.rental_application_url !== '') {
      url = listing.office_details.office.rental_application_url
    }
  }

  return windowSize && windowSize.width <= 767 ? (
    <G.MobileNav justifyBetween={!!phoneNumber && hasInspection} scrolled={scrolled}>
      <G.MobileNavItem onClick={() => setShowEnquiryForm(true)}>
        <IconEmail />
        Enquire
      </G.MobileNavItem>
      {phoneNumber && (
        <a href={`tel:${phoneNumber}`}>
          <G.MobileNavItem>
            <IconMobile />
            Call
          </G.MobileNavItem>
        </a>
      )}
      <MakeOfferButton isMobile id='mobile-offer-button' listing={listing} />

      {hasInspection && (
        <G.MobileNavItem onClick={goToInspectionSection}>
          <IconInspect />
          Inspect
        </G.MobileNavItem>
      )}

      {url !== '' && (
        <a href={url} target='_blank'>
          <G.MobileNavItem>
            <IconApply />
            Apply Now
          </G.MobileNavItem>
        </a>
      )}

    </G.MobileNav>
  ) : null
}

export default PropertyMobileNav
